import { useSelector } from 'react-redux'
import { selectDisplayType } from '../../store/slice'
import { DYNAMIC_CONTAINER } from '../config'
import FinancePanel from './FinancePanel'

const PanelContainer = () => {
  const displayType = useSelector(selectDisplayType)
  const mapPanel = DYNAMIC_CONTAINER[displayType]

  return (
    <>
      {mapPanel.map((item) => (
        <FinancePanel
          key={item.dynamicKey}
          config={item}
          displayType={displayType}
        />
      ))}
    </>
  )
}

export default PanelContainer
